import { ErrorMessage } from "@hookform/error-message";
import React from "react";
import { useController, useFormContext, useFormState } from "react-hook-form";
import { Label, Input } from "reactstrap";

const styles = {
  required: {
    color: "#d04437",
  },
};

const FormInput = ({ label, name, type, required, children, ...props }) => {
  const { control } = useFormContext();

  const {
    field: { ref, ...inputProps },
    // fieldState: { invalid, isTouched, isDirty },
    // formState: { touchedFields, dirtyFields },
  } = useController({
    name,
    control,
    rules: { required: required },
  });

  const { errors } = useFormState();
  return (
    <>
      {label && (
        <Label>
          {label}
          {required && <span style={styles.required}>*</span>}
        </Label>
      )}
      <Input
        name={name}
        type={type}
        innerRef={ref}
        {...inputProps}
        {...props}
        invalid={errors[name]}
      >
        {children}
      </Input>
      <ErrorMessage errors={errors} name={name} />
    </>
  );
};

export default FormInput;
